<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	.mui-switch-blue.mui-active {
		border: 2px solid #03D0fa !important;
		background-color: #03D0fa !important;
	}
	
    .mui-table-view-cell {
		padding: 1px !important;
		height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue